import React, {Component} from 'react';
import {Navigate, Route, Routes} from 'react-router';
import Layout from './components/Common/Layout';
import JourneyListWrapper from './components/Journey/JourneyList';
import {VehicleList} from './components/Vehicle/VehicleList';
import CrashReports from './components/Crash/CrashReports';
import UserManagement from './components/Management/User/UserManagement';
import AddUser from './components/Management/User/AddUser';
import EditUser from './components/Management/User/EditUser';
import CompanyManagement from './components/Management/Company/CompanyManagement';
import AddCompany from './components/Management/Company/AddCompany';
import EditCompany from './components/Management/Company/EditCompany';
import GroupManagement from './components/Management/Group/GroupManagement';
import AddGroup from './components/Management/Group/AddGroup';
import EditGroup from './components/Management/Group/EditGroup';
import UserGroup from './components/Management/Group/UserGroup';
import VehicleGroup from './components/Management/Group/VehicleGroup';
import AddUserGroup from './components/Management/Group/AddUserGroup';
import AddVehicleGroup from './components/Management/Group/AddVehicleGroup';
import RequestAccess from './components/Common/RequestAccess';
import NotSystemAdmin from './components/Common/NotSystemAdmin';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import CompanyOverview from "./components/CompanyOverview/CompanyOverview";
import Overview from "./components/DeviceOverview/DeviceOverview";
import CrashInspection from "./components/Crash/CrashInspection";
import Leaderboards from './components/Leaderboards/Leaderboards';
import TamperReports from "./components/Crash/TamperReports";
import VehicleLastLocation from "./components/VehicleLastLocation/VehicleLastLocation";
import Loading from "./components/Common/Loading";
import {JourneyListWrapperDebug} from "./components/Journey/JourneyListDEBUG";
import RegisterDevice from "./components/Management/Register/RegisterDevice";
import RegisterDeviceIC6 from "./components/Management/Register/RegisterDeviceIC6";
import {VehicleManagement} from "./components/Management/Vehicle/VehicleManagement";
import DeviceMovementForm from "./components/Management/Register/MoveDevice";
import SwitchCustomer from "./components/Management/Register/SwitchCustomer";
import RegisterAppAccount from "./components/Management/Register/RegisterAppAccount";
import {WaylensEventList} from "./components/Waylens/WaylensEventList";
import {WaylensEventDetail} from "./components/Waylens/WaylensEventDetail";
import WaylensGeofences from "./components/Waylens/WaylensGeofences";


export default class App extends Component {

    displayName = App.name
    userManager = null;

    constructor(props) {
        super(props);

        this.state = {
            authority: null,
            userManager: null,
            userLoggedIn: false,
            userAccessToken: null,
            userEmail: '',
            userManagerChecked: false,
            roles: {},
            rolesChecked: false,
            company: null,
            companyChecked: false,
            hereMapsApikey: null,
            mapBoxApiKey: null,
            loading: true,
            speedUnit: null
        };
    }

    componentDidMount() {
        fetch('api/Config')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(async data => {
                const settings = {
                    authority: data.authority,
                    client_id: data.clientId,
                    post_logout_redirect_uri: data.postLogOutUri,
                    redirect_uri: data.redirectUri,
                    response_type: 'id_token token',
                    scope: `openid profile ${data.scope}`,
                    accessTokenExpiringNotificationTime: 60,
                    automaticSilentRenew: true,
                    silent_redirect_uri: window.location.origin + "/silent.html",
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                    userStore: new WebStorageStateStore({store: window.localStorage})
                };
                let userManager = new UserManager(settings);
                this.userManager = userManager;
                this.wireAuthEvents(userManager);

                this.setState({
                    userManager: userManager,
                    authority: data.authority,
                    hereMapsApikey: data.hereMapsApikey,
                    mapBoxApiKey: data.mapBoxApiKey,
                    loading: false,
                });
                await this.getUserIfLoggedIn();
            })
            .catch(error => {
            });
    }

    getReturnPath = () => {
        const { pathname, search, hash } = window.location;
        return `${pathname}${search}${hash}` || "/";
    };

    startSigninRedirect = async () => {
        const returnPath = this.getReturnPath();
        sessionStorage.setItem("postLoginRedirect", returnPath);
        await this.userManager.signinRedirect({ state: returnPath });
    };

    renderAdminRoute = (element) => {
        if (!this.state.rolesChecked) {
            return <Loading />;
        }

        return this.state.isAdmin ? element : <Navigate to="/" />;
    };

    wireAuthEvents = (mgr) => {
        mgr.events.addUserLoaded(user => {
            this.setState({
                userLoggedIn: true,
                userAccessToken: user?.access_token ?? null,
                userEmail: user?.profile?.name ?? ""
            });
        });

        mgr.events.addAccessTokenExpiring(() => {
        });

        mgr.events.addAccessTokenExpired(async () => {
            try {
                const u = await mgr.signinSilent();
                this.setState({ userAccessToken: u?.access_token ?? null, userLoggedIn: true });
            } catch {
                await this.startSigninRedirect();
            }
        });

        mgr.events.addSilentRenewError(async () => {
            await this.startSigninRedirect();
        });
    };

    async getUserIfLoggedIn() {
        try {
            const user = await this.userManager.getUser();
            const isLoggedIn = !!user && !user.expired;

            this.setState({
                userManagerChecked: true,
                userAccessToken: user ? user.access_token : null,
                userEmail: user ? user.profile.name : "",
                userLoggedIn: isLoggedIn,
                isAuthorisedUser: false
            }, async () => {
                if (isLoggedIn) {
                    await this.getUserStatus();
                }
            });

            if (!isLoggedIn) {
                await this.startSigninRedirect();
            }
        } catch (error) {
            console.error(error);
            this.setState({
                userManagerChecked: true,
                isAdmin: false,
                isUser: false,
                userLoggedIn: false,
                isAuthorisedUser: false
            });
        }
    }

    apiFetch = async (input, init = {}) => {
        const user = await this.userManager.getUser();
        let token = user?.access_token ?? null;

        const headers = new Headers(init.headers || {});
        if (token) headers.set('Authorization', `Bearer ${token}`);
        headers.set('Accept', 'application/json');

        let resp = await fetch(input, { ...init, headers });

        if (resp.status === 401) {
            try {
                const u = await this.userManager.signinSilent();
                token = u?.access_token ?? null;
                const retryHeaders = new Headers(init.headers || {});
                if (token) retryHeaders.set('Authorization', `Bearer ${token}`);
                retryHeaders.set('Accept', 'application/json');
                resp = await fetch(input, { ...init, headers: retryHeaders });
            } catch {
                await this.startSigninRedirect();
                return resp;
            }
        }

        return resp;
    };


    async getUserStatus() {
        try {
            const url = '/api/Report/GetUserStatus';

            let response = await this.apiFetch(url);
            if (response.status === 401) {
                try {
                    const u = await this.userManager.signinSilent();
                    this.setState({ userAccessToken: u?.access_token ?? null, userLoggedIn: true });
                    response = await this.apiFetch(url);
                } catch {
                    await this.startSigninRedirect();
                    return;
                }
            }

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.setState({
                roles: data.roles,
                rolesChecked: true,
                isAuthorisedUser: data.isAuthorisedUser,
                isAdmin: data.isAdmin,
                speedUnit: data.speedUnit
            });
        } catch (error) {
            console.error(error);
        }
    }


    render() {
        if (this.state.loading) {
            return (
                <div style={{backgroundColor: 'black'}}>
                    <Loading/>
                </div>
            );
        }

        if (this.state.userLoggedIn === true) {
            return (
                <Layout
                    apiFetch={this.apiFetch}
                    userManager={this.state.userManager}
                    roles={this.state.roles}
                    authority={this.state.authority}
                    userLoggedIn={this.state.userLoggedIn}
                    isUser={this.state.isUser}
                    isAuthorisedUser={this.state.isAuthorisedUser}
                    userEmail={this.state.userEmail}
                    isAdmin={this.state.isAdmin}
                >
                    <Routes>
                        <Route path='/' element={<CompanyOverview apiFetch={this.apiFetch} roles={this.state.roles} speedUnit={this.state.speedUnit}/>} />
                        <Route path='/vehicle-list' element={<VehicleList apiFetch={this.apiFetch} roles={this.state.roles} userEmail={this.state.userEmail} />} />
                        <Route path='/vehicle-management' element={this.renderAdminRoute(<VehicleManagement apiFetch={this.apiFetch} roles={this.state.roles} userEmail={this.state.userEmail}/>)} />
                        <Route path='/leaderboards' element={<Leaderboards apiFetch={this.apiFetch} roles={this.state.roles} speedUnit={this.state.speedUnit}/>} />
                        <Route path='/vehicles/:vehiclereference' element={<JourneyListWrapper apiFetch={this.apiFetch} roles={this.state.roles} speedUnit={this.state.speedUnit} mapBoxApiKey={this.state.mapBoxApiKey}  />} />
                        <Route path='/vehiclesDebug/:vehiclereference' element={<JourneyListWrapperDebug apiFetch={this.apiFetch} roles={this.state.roles} speedUnit={this.state.speedUnit} mapBoxApiKey={this.state.mapBoxApiKey}/>} />
                        <Route path='/crash/crash-list' element={<CrashReports apiFetch={this.apiFetch} roles={this.state.roles} />} />
                        <Route path='/tamper-list' element={<TamperReports apiFetch={this.apiFetch} roles={this.state.roles} />} />
                        <Route path='/crash/:vehiclereference/:crashid' element={<CrashInspection apiFetch={this.apiFetch} roles={this.state.roles} mapBoxApiKey={this.state.mapBoxApiKey}/>} />
                        <Route path='/requestaccess' element={<RequestAccess apiFetch={this.apiFetch} roles={this.state.roles} />} />
                        <Route path='/notsystemadmin' element={<NotSystemAdmin apiFetch={this.apiFetch} roles={this.state.roles} />} />
                        <Route path='/company-overview' element={<CompanyOverview apiFetch={this.apiFetch} roles={this.state.roles} userEmail={this.state.userEmail} />} />
                        <Route path='/deviceOverview/:vehiclereference' element={<Overview apiFetch={this.apiFetch} roles={this.state.roles} speedUnit={this.state.speedUnit} />} />
                        <Route path='/last-activity' element={<VehicleLastLocation apiFetch={this.apiFetch} roles={this.state.roles} userEmail={this.state.userEmail} mapBoxApiKey={this.state.mapBoxApiKey} />} />
                        <Route path='/switch-customer' element={this.renderAdminRoute(<SwitchCustomer apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/move-device' element={this.renderAdminRoute(<DeviceMovementForm apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/register/registerdevice' element={this.renderAdminRoute(<RegisterDevice apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/register/registerdeviceIC6' element={this.renderAdminRoute(<RegisterDeviceIC6 apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/register/registerappaccount' element={this.renderAdminRoute(<RegisterAppAccount apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/usermanagement' element={this.renderAdminRoute(<UserManagement apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/adduser' element={this.renderAdminRoute(<AddUser apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/edituser' element={this.renderAdminRoute(<EditUser apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/companymanagement' element={this.renderAdminRoute(<CompanyManagement apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/addcompany' element={this.renderAdminRoute(<AddCompany apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/editcompany' element={this.renderAdminRoute(<EditCompany apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/groupmanagement' element={this.renderAdminRoute(<GroupManagement apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/addgroup' element={this.renderAdminRoute(<AddGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/editgroup' element={this.renderAdminRoute(<EditGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/usergroup' element={this.renderAdminRoute(<UserGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/vehiclegroup' element={this.renderAdminRoute(<VehicleGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/addusergroup' element={this.renderAdminRoute(<AddUserGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path='/admin/addvehiclegroup' element={this.renderAdminRoute(<AddVehicleGroup apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path="/waylens" element={this.renderAdminRoute(<WaylensEventList apiFetch={this.apiFetch} roles={this.state.roles} />)} />
                        <Route path="/waylens/geofences" element={this.renderAdminRoute(<WaylensGeofences apiFetch={this.apiFetch} mapBoxApiKey={this.state.mapBoxApiKey} />)} />
                        <Route path="/waylens/event/:id" element={this.renderAdminRoute(<WaylensEventDetail apiFetch={this.apiFetch} roles={this.state.roles} mapBoxApiKey={this.state.mapBoxApiKey} />)} />
                    </Routes>
                </Layout>
            );
        } else if (this.state.userManager !== null) {
            this.startSigninRedirect();
        } else {
            return <div style={{backgroundColor: 'black'}}> <p> Loading </p> </div>
        }
    }
}
